import { APICallV3Post } from 'reactApp/api/APICall';

export class SubscriptionRenewAPICall extends APICallV3Post {
    _method = 'billing/subscription/renew';
}

